import { useEffect, useRef, useState } from "react";
import SideNavLayout from "../customsidenav/sidenavlayout";
import dayjs from "dayjs";
import NavigationMenu from "./navigationmenu";
import api from "../api/api";
import CardView from "./cards/cardview";
import ExpandedView from "./cards/expandedcard";
import { Backdrop, CircularProgress } from "@mui/material";
import PcardPopup from "./modals/pcard";
import StatusNotesPopUp from "./modals/statusnotes";
import ModalOverlay from "./modals/pmodal";
import useStore from "../store/zustandstore";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { use } from "react";
import Dashfilter from "./modals/Dashfilter";
import { objs } from "./junk";
import ImagingModal from "./modals/imagingmodal";
import PcardPopupNew from "./modals/pacrdnew";
import DashboardFilterModal from "./modals/dashboardfilters";
import ToastMessage from "../utils/mui/righttoptoast";
import ChatWrapper from "../header/chat/chatwrapper";
import CreateAppointment from "../schedule/modals/createAppointment";
import ModalSwitch from "../schedule/modals/modalswitch";
import { eventBus } from "../utils/eventBus";
import html2canvas from "html2canvas";

const formatDate = (dateString) => {
  return dayjs(dateString).format("YYYY-MM-DD");
};

const CareLanding = () => {
  const currentDate = useSelector((state) => state.filter.currentDate);
  const tab = useSelector((state) => state.filter.tab);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [imagingmodal, setImagingModal] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [startdate, setStartDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [isloader, setIsLoader] = useState(false);
  const [dbscount, setDbCount] = useState({});
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filtermodal, setFiltermodal] = useState(false);
  const [selectedFilterName, setSelectedFilterName] = useState();
  const [appliedFilter, setAppliedFilter] = useState();
  const [fetchedData, setFetchedData] = useState([]);
  const [searchdate, setSearchDate] = useState(formatDate(new Date()));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStatusNotesPopUp, setIsStatusNotesPopUp] = useState(false);
  const [isPcard, setIsPcard] = useState(false);
  const [isCardView, setIsCardView] = useState(true);
  const [selectedCard, setSelectedCard] = useState({});
  const [signInPatient, setSignInPatient] = useState(state?.item || null);
  const [searchedUser, setSearchedUser] = useState(null);
  const setSidenav = useStore((state) => state.setSidenav);
  const setmessagecount = useStore((state) => state.setMessagecount);
  const setPendingcount = useStore((state) => state.setPendingcount);
  const practiseid = window.getPracticeId();
  const [dashboardfilter, setDashboardfilter] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isfutureappointment, setIsFutureAppointment] = useState(false);
  const isloaderactive = useRef(true);
  const location = useLocation();
  const dob = useRef("");
  const userConfig = useSelector((state) => state.userconfig);
  console.log(userConfig, "userConfig");
  const [scheduleStates, setScheduleStates] = useState({});
  const [chat, setChat] = useState(false);
  const data = useRef("");
  const navigate = useNavigate();
  //schedular -states
  const [screen, setScreen] = useState(0);
  const [isAptCard, setIsAptCard] = useState(false);
  const [appointmentCardopen, setIsappointmentCardOpen] = useState(false);
  // ✅ Extract query parameters
  const queryParams = new URLSearchParams(location.search);
  const gettab = queryParams.get("tab"); // "5"
  const subtab = queryParams.get("subtab"); // "1"
  const onmodal = queryParams.get("onmodal") === "true"; // true or false
  const date = queryParams.get("date"); // e.g., "2025-06-25"
  const [validpayments, setValidPayments] = useState([]);
  // ✅ Extract state object
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [rpmvalues, setRpmValues] = useState([]);
  const [toastSeverity, setToastSeverity] = useState("success");
  const handleToastClose = () => {
    setOpenToast(false);
  };
  useEffect(() => {
    document.title = "CHIM - Dashboard";
    if (!isModalOpen) {
      setSidenav(true);
    }
  }, [isModalOpen]);
  const { myData } = location.state || {};
  useEffect(() => {
    const hasQueryParams = gettab && subtab && date && onmodal !== null;
    const hasMyData =
      myData && typeof myData === "object" && Object.keys(myData).length > 0;

    if (hasQueryParams && hasMyData) {
      setSidenav(false);
      setSelectedCard(myData);
      setIsModalOpen(true);

      //     setSearchedUser({
      //   patientid: myData.patientid,
      //  patientinfo: myData.patient_name
      // });
    }
  }, [tab, subtab, date, onmodal, myData]);
  let payload = {
    appointmentdate: currentDate,
    searchflag: state?.item?.patientid || null,
    dashfilter: tab,
    filterarr: [],
    start: 0,
    limit: 0,
  };

  const fetchCount = async () => {
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/dbscounts`,
        {
          type: "APT",
          userid: "all",
          searchdate: currentDate,
        },
      );
      if (response.status == 200) {
        if (response?.data?.length) {
          setDbCount(response.data[0]);
          setmessagecount(response?.data[0]?.messages || 0);
          setPendingcount(response?.data[0]?.pendingtasks || 0);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  // const markAsComplete = async (ids, task) => {
  //   try {
  //     // Check if the task is an array or a single task object
  //     const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

  //     if (!taskToProcess) {
  //       console.error("No task data available");
  //       return;
  //     }

  //     const payload = {
  //       ids: ids,
  //       status: taskToProcess.status,
  //       notes: taskToProcess.notes,
  //       orderdate: dayjs(taskToProcess.ts).format("YYYY-MM-DD"),
  //       login_user: userConfig?.username,
  //       ordertype: taskToProcess.ordertype,
  //       username: userConfig?.username,
  //     };

  //     // Make API call to mark as complete
  //     const response = await api.put(
  //       `/v1/${practiseid}/tasks/${taskToProcess.patientid}/mark_as_complete`,
  //       payload
  //     );

  //     if (response.status === 200) {

  //   for (let taskId of ids) {
  //     // Find the task by ID from the tasks array
  //     const taskToAthena = task.find(tasks => tasks.id === taskId);
  //       if (
  //         taskToAthena.ordername === "COVID TEST" ||
  //         taskToAthena.ordername === "STREP TEST" ||
  //         taskToAthena.ordername === "FLU TEST"
  //       ) {
  //           const appurl = window.location.origin;
  //           const fileUrl = `${appurl}/imaging/strep-covid-flu-Preview/${ids}`;

  //           try {
  //             const observationDate = dayjs().format("MM/DD/YYYY");
  //             const observationTime = dayjs().format("HH:mm");
  //             const departmentid = 1;

  //             // Create a hidden iframe to load the preview page
  //             const iframe = document.createElement("iframe");
  //             iframe.style.position = "fixed";
  //             iframe.style.top = "-10000px";
  //             iframe.style.left = "-10000px";
  //             iframe.style.width = "1200px";
  //             iframe.style.height = "900px";
  //             iframe.style.border = "none";
  //             document.body.appendChild(iframe);

  //             // Wait for iframe to load
  //             await new Promise((resolve, reject) => {
  //               iframe.onload = resolve;
  //               iframe.onerror = () => reject(new Error("Failed to load preview page"));
  //               iframe.src = fileUrl;
  //             });

  //             // Wait for the report to be fully rendered (has id="report-ready")
  //             const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
  //             let reportElement = null;
  //             for (let i = 0; i < 20; i++) {
  //               reportElement = iframeDoc.getElementById("report-ready");
  //               if (reportElement) break;
  //               await new Promise((res) => setTimeout(res, 500));
  //             }

  //             // Fallback to body if report element not found
  //             const captureElement = reportElement || iframeDoc.body;

  //             // Capture only the report element as a canvas
  //             const canvas = await html2canvas(captureElement, {
  //               useCORS: true,
  //               allowTaint: true,
  //               scale: 2,
  //               backgroundColor: "#ffffff",
  //             });

  //             // Remove the iframe after capture
  //             document.body.removeChild(iframe);

  //             // Convert canvas to JPG blob
  //             const fileBlob = await new Promise((resolve) =>
  //               canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.95)
  //             );

  //             const formData = new FormData();
  //             formData.append("file", fileBlob, "file.jpg");
  //             formData.append("attachmenttype", "JPG");
  //             formData.append("observationdate", observationDate);
  //             formData.append("observationtime", observationTime);
  //             formData.append("autoclose", true);

  //             const uploadResponse = await api.post(
  //               `/v1/${practiseid}/${departmentid}/patient/${taskToProcess.patientid}/add-strepcovidflu-athena`,
  //               formData,
  //               {
  //                 headers: {
  //                   "Content-Type": "multipart/form-data",
  //                 },
  //               }
  //             );

  //             setToastMessage(
  //               `File uploaded successfully: ${JSON.stringify(uploadResponse.data)}`
  //             );
  //           } catch (error) {
  //             setToastMessage(`Request failed: ${error.message}`);
  //           } finally {
  //             setLoading(false);
  //           }
  //       }
  //   }

  //       // Refetch the data after completing the task
  //       setToastSeverity("success");
  //       setToastMessage(response.message);
  //       setOpenToast(true);

  //       // Refresh dashboard data to show updated task status
  //    await fetchDashboardData({
  //      searchflag:fetchedData?.length>1?"": (taskToProcess?.patientid || ""),
  //         filter: appliedFilter || "",
  //         labels: selectedFilterName || {},
  //         appointmentdate: currentDate,
  //       });

  //       // Also refresh the counts
  //       await fetchCount();

  //       console.log("Task marked as complete successfully");
  //     } else {
  //       setToastSeverity("info");
  //       setToastMessage(response.message);
  //       setOpenToast(true);
  //       console.error("Error marking task as complete");
  //     }
  //   } catch (error) {
  //     setToastSeverity("error");
  //     setToastMessage("Something Went Wrong");
  //     setOpenToast(true);
  //     console.error("Error marking task as complete:", error);
  //   }
  // };

  const markAsComplete = async (ids, tasks) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(tasks) ? tasks[0] : tasks; // Use the first task if it's an array

      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }

      const payload = {
        ids: ids,
        status: taskToProcess.status,
        notes: taskToProcess.notes,
        orderdate: dayjs(taskToProcess.ts).format("YYYY-MM-DD"),
        login_user: userConfig?.username,
        ordertype: taskToProcess.ordertype,
        username: userConfig?.username,
      };

      // Make API call to mark as complete
      const response = await api.put(
        `/v1/${practiseid}/tasks/${taskToProcess.patientid}/mark_as_complete`,
        payload,
      );

      if (response.status === 200) {
        // Iterate over the selected IDs and process each task
        for (let taskId of ids) {
          // Find the task by ID from the tasks array
          // Log taskId and tasks array to check what we're working with
          console.log(`Checking taskId: ${taskId}`);
          console.log("Tasks array:", tasks);

          // Check if taskId is the correct type (number or string)
          console.log(`taskId type: ${typeof taskId}`);

          // Find the task by ID from the tasks array
          const taskToAthena = tasks.find((task) => task.id === Number(taskId));
          // const taskToAthena = tasks.find(task => {
          //   console.log(`Comparing task.id: ${task.id} with taskId: ${taskId}`);
          //   return task.id === taskId;
          // });

          // Log the result of find operation
          console.log("Found taskToAthena:", taskToAthena);
          // Check if taskToAthena was found
          if (!taskToAthena) {
            console.error(`Task with ID ${taskId} not found.`);
            continue; // Skip to the next task if not found
          }

          // Check if the task is one of the special tests
          if (
            taskToAthena.ordername === "COVID TEST" ||
            taskToAthena.ordername === "STREP TEST" ||
            taskToAthena.ordername === "FLU TEST"
          ) {
            const appurl = window.location.origin;
            const fileUrl = `${appurl}/imaging/strep-covid-flu-Preview/${taskId}`;

            try {
              const observationDate = dayjs().format("MM/DD/YYYY");
              const observationTime = dayjs().format("HH:mm");
              const departmentid = window.getDepartmentId();

              // Create a hidden iframe to load the preview page
              const iframe = document.createElement("iframe");
              iframe.style.position = "fixed";
              iframe.style.top = "-10000px";
              iframe.style.left = "-10000px";
              iframe.style.width = "1200px";
              iframe.style.height = "900px";
              iframe.style.border = "none";
              document.body.appendChild(iframe);

              // Wait for iframe to load
              await new Promise((resolve, reject) => {
                iframe.onload = resolve;
                iframe.onerror = () =>
                  reject(new Error("Failed to load preview page"));
                iframe.src = fileUrl;
              });

              // Wait for the report to be fully rendered (has id="report-ready")
              const iframeDoc =
                iframe.contentDocument || iframe.contentWindow.document;
              let reportElement = null;
              for (let i = 0; i < 20; i++) {
                reportElement = iframeDoc.getElementById("report-ready");
                if (reportElement) break;
                await new Promise((res) => setTimeout(res, 500));
              }

              // Fallback to body if report element not found
              const captureElement = reportElement || iframeDoc.body;

              // Capture only the report element as a canvas
              const canvas = await html2canvas(captureElement, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
                backgroundColor: "#ffffff",
              });

              // Remove the iframe after capture
              document.body.removeChild(iframe);

              // Convert canvas to JPG blob
              const fileBlob = await new Promise((resolve) =>
                canvas.toBlob((blob) => resolve(blob), "image/jpeg", 0.95),
              );

              const formData = new FormData();
              formData.append("file", fileBlob, "file.jpg");
              formData.append("attachmenttype", "JPG");
              formData.append("observationdate", observationDate);
              formData.append("observationtime", observationTime);
              formData.append("autoclose", true);

              const uploadResponse = await api.post(
                `/v1/${practiseid}/${departmentid}/patient/${taskToProcess.patientid}/add-strepcovidflu-athena`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
              );

              setToastMessage(
                `File uploaded successfully: ${JSON.stringify(uploadResponse.data)}`,
              );
            } catch (error) {
              setToastMessage(`Request failed: ${error.message}`);
            } finally {
              setLoading(false);
            }
          }
        }

        // Refetch the data after completing the task
        setToastSeverity("success");
        setToastMessage(response.message);
        setOpenToast(true);

        // Refresh dashboard data to show updated task status
        await fetchDashboardData({
          searchflag:
            fetchedData?.length > 1 ? "" : taskToProcess?.patientid || "",
          filter: appliedFilter || "",
          labels: selectedFilterName || {},
          appointmentdate: currentDate,
        });

        // Refresh the counts
        await fetchCount();

        console.log("Task marked as complete successfully");
      } else {
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
        console.error("Error marking task as complete");
      }
    } catch (error) {
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error marking task as complete:", error);
    }
  };

  const markAscancel = async (ids, task) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }

      // Construct the payload for the cancel action
      const payload = {
        ids: ids, // Pass the task ids (task.id or array of ids)
        notes: taskToProcess.notes, // Use notes from the task
        st_date: dayjs(taskToProcess.ts).format("YYYY-MM-DD"), // Format the timestamp
        login_user: userConfig?.username, // Logged in user info
      };

      // Make API call to mark as decline (cancel)
      const response = await api.put(
        `/v1/${practiseid}/tasks/mark_as_decline`,
        payload,
      );

      if (response.status === 200) {
        setToastSeverity("success");
        setToastMessage(response.message);
        setOpenToast(true);

        // Refresh dashboard data to show updated task status
        await fetchDashboardData({
          searchflag:
            fetchedData?.length > 1 ? "" : taskToProcess?.patientid || "",
          filter: appliedFilter || "",
          labels: selectedFilterName || {},
          appointmentdate: currentDate,
        });

        // Also refresh the counts
        await fetchCount();

        console.log("Task marked as cancelled successfully");
      } else {
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
        console.error("Error marking task as cancelled");
      }
    } catch (error) {
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error marking task as cancelled:", error);
    }
  };

  const handleconfirmScheduleClick = async (order) => {
    try {
      // Create the payload to send the status update

      const newStatusFlag = selectedOrder.schedule === "t" ? "f" : "t"; // Toggle status for this specific order

      console.log(newStatusFlag);
      setScheduleStates((prevState) => ({
        ...prevState,
        [order.id]: newStatusFlag, // Update only this specific order's status
      }));

      // Create the payload to send the status update
      const payload = {
        orderid: order.id,
        statusflag: newStatusFlag,
        login_user: userConfig.username,
      };
      // Call API to update status flag
      const response = await api.put(
        `/v1/${practiseid}//tasks/update_status_schedule`,
        payload,
      );

      if (response.status === 200) {
        // If the update was successful, refresh data if necessary
        //  fetchdata({ dt: selectedDate.format('YYYY-MM-DD'), st: selectedStatus,ct:selectedCategory, searchQuery,isfilter:true });
        setScheduleStates({});
      } else {
        console.error("Error updating status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  const insertdata = (X) => {
    data.current = X;

    getdob(X?.patientid);

    setImagingModal(true);
  };

  const fetchDashboardData = async ({
    searchflag,
    filter = "",
    labels,
    appointmentdate,
    tabFilter,
  }) => {
    console.log("filter", filter);

    setSelectedFilterName(labels);
    if (filter && typeof filter === "object") setAppliedFilter(filter);
    setLoading(true);

    // Create a new payload object to avoid mutating the original
    const requestPayload = {
      appointmentdate: appointmentdate || currentDate,
      searchflag: state?.item?.patientid || null,
      dashfilter: tabFilter || tab, // Use tabFilter if provided, otherwise fall back to Redux tab
      filterarr: [],
      start: 0,
      limit: 0,
    };

    const todayDateString = new Intl.DateTimeFormat("en-US", {
      timeZone: "UTC",
      timeZoneName: "short",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());

    const todaydate = new Date(todayDateString).setHours(0, 0, 0, 0);
    // const todaydate = new Date().setHours(0, 0, 0, 0);
    if (requestPayload.dashfilter) {
      const appointmentDateOnly = new Date(
        requestPayload.appointmentdate,
      ).setHours(0, 0, 0, 0);
      if (appointmentDateOnly !== todaydate) {
        requestPayload.dashfilter = null;
      }
    }
    if (searchflag) {
      requestPayload.searchflag = searchflag;
      requestPayload.dashfilter = null;
    }
    if (filter) {
      requestPayload.filterarr = [filter];
    }
    try {
      const response = await api.post(
        `/v1/${practiseid}/appointments/dashboard`,
        requestPayload,
      );
      if (response.status === 200) {
        const newData = response.data || [];
        // console.log('State',state)
        // if (state?.item?.patientid) {
        //   newData = newData.filter((item) => item.patientid === state?.item?.patientid);
        //   console.log("Filtered Data", newData);

        // }
        setFetchedData(newData);
      } else {
        setFetchedData([]);
      }
    } catch (error) {
      console.log(error);
      setFetchedData([]);
    } finally {
      setLoading(false);
    }
  };

  // Helper to refresh dashboard with current filters/date
  const refreshDashboard = async (patientId) => {
    await fetchDashboardData({
      searchflag: patientId || "",
      filter: appliedFilter || "",
      labels: selectedFilterName || {},
      appointmentdate: currentDate,
    });
    await fetchCount();
  };

  // Function to clear search user
  const clearSearchUser = () => {
    setSearchedUser(null);
  };

  const hasHandledFromPatient = useRef(false);
  const appliedFilterRef = useRef(appliedFilter);
  const selectedFilterNameRef = useRef(selectedFilterName);

  // Update refs when filters change
  useEffect(() => {
    appliedFilterRef.current = appliedFilter;
    selectedFilterNameRef.current = selectedFilterName;
  }, [appliedFilter, selectedFilterName]);

  useEffect(() => {
    const run = async () => {
      const fromPatientId = location.state?.fromPatientId;
      try {
        // ✅ Handle fromPatientId only once
        if (fromPatientId && !hasHandledFromPatient.current) {
          hasHandledFromPatient.current = true;
          setLoading(true);
          const response = await api.post(
            `/v1/${practiseid}/autocomplete/dssearch`,
            {
              searchtxt: fromPatientId,
            },
          );
          if (response.status === 200) {
            const fetchedDob = response.data?.[0]?.dob;
            const patient = response.data[0];
            if (fetchedDob) {
              // ensures it's not null, undefined, or empty
              dob.current = fetchedDob;
            }
            setSearchedUser({
              patientid: patient.patientid,
              patientinfo: patient.patientinfo,
              lastname: patient.lastname,
            });
            //    setSearchedUser({
            //   patientid: patient.patientid,
            //   patientinfo:
            //     patient.patient_name ||
            //     `${patient.firstname || ""} ${patient.lastname || ""}`
            // });
          }
          await fetchDashboardData({ searchflag: fromPatientId });

          await getvalidpayments();
          console.log("calling from search");

          // ✅ Clear fromPatientId after use
          navigate(location.pathname + location.search, {
            replace: true,
            state: null,
          });
          return;
        }

        if (currentDate) {
          payload.appointmentdate = currentDate;
          // Preserve existing filters when date changes
          fetchDashboardData({
            searchflag: "",
            filter: appliedFilterRef.current || "",
            labels: selectedFilterNameRef.current || {},
          });
          console.log("calling from date");
          fetchCount();
          getvalidpayments();
        } else {
          fetchDashboardData({ searchflag: "" });
          getvalidpayments();
          console.log("calling empty");
        }
      } catch (error) {
        console.log(error);
      } finally {
        //setLoading(false)
      }
    };

    run();
  }, [currentDate, tab, location.pathname, location.search, navigate]);

  const openModal = (x) => {
    setSidenav(false);
    setSelectedCard(fetchedData?.find((y) => y.id === x));
    // console.log(fetchedData?.find((y) => y.id === x))
    setIsModalOpen(true);
  };

  // Listen for thread notification click to open patient chart at Threads tab
  useEffect(() => {
    const handleOpenPatientThread = (payload) => {
      const { patientid } = payload || {};
      if (!patientid) return;
      const card = fetchedData?.find((y) => y.patientid === patientid);
      if (card) {
        setSidenav(false);
        setSelectedCard(card);
        setIsModalOpen(true);
        setTimeout(() => {
          eventBus.emit("navigateToThreadsTab", { tab: 10 });
        }, 100);
      }
    };

    eventBus.on("openPatientThread", handleOpenPatientThread);
    return () => {
      eventBus.off("openPatientThread", handleOpenPatientThread);
    };
  }, [fetchedData]);
  const getvalidpayments = async () => {
    try {
      const reponse = await api.get(`/v1/${practiseid}/lookup_master/valid`);

      const rpmdetails = await api.get(
        `/v1/${practiseid}/rpm/bpp-master/latest`,
      );
      if (rpmdetails.status == 200) {
        setRpmValues(rpmdetails?.data || []);
      } else {
        setRpmValues([]);
      }
      if (reponse.status == 200) {
        setValidPayments(reponse.data || []);
      } else {
        setValidPayments([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fetchpcarddata = (x) => {
    setSelectedCard(fetchedData?.find((y) => y.id === x));
    setIsPcard(true);
  };
  const closeModal = () => {
    // setSidenav(true);
    setIsModalOpen(false);
  };
  const getdob = async (query) => {
    try {
      setLoading(true);
      const response = await api.post(
        `/v1/${practiseid}/autocomplete/dssearch`,
        {
          searchtxt: query,
        },
      );
      if (response.status === 200) {
        const fetchedDob = response.data?.[0]?.dob;
        if (fetchedDob) {
          // ensures it's not null, undefined, or empty
          dob.current = fetchedDob;
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleschedular = async (appointment) => {
    try {
      console.log(appointment, "appointment");
      setLoading(true);
      const payload = {
        startdate: currentDate,
      };

      const response = await api.post(
        `/v1/${practiseid}/scheduler/schedule_list`,
        payload,
      );
      if (response.status == 200 && response?.data?.length) {
        console.log("go to if", appointment.patientid);
        const filteredAppointments = response?.data.filter((app) => {
          return String(app.patientid) === String(appointment?.patientid);
        });

        console.log(filteredAppointments, "filter");
        if (filteredAppointments?.length) {
          setIsFutureAppointment(false);
          console.log("appointment1 ", appointment);
          setSelectedAppointment({
            ...filteredAppointments[0],
            signintime: appointment?.signintime ?? null,
          });

          setScreen(1);
          setIsAptCard(true);
        } else {
          console.log("camehere");
          const appointmentsdata = await api.get(
            `/v1/${practiseid}/appointments/${appointment?.patientid}/future`,
          );
          if (appointmentsdata.status == 200) {
            setIsFutureAppointment(true);
            console.log("appointment2 ", appointment);
            setSelectedAppointment({
              ...(appointmentsdata?.data?.[0] || {}),
              signintime: appointment?.signintime ?? null,
            });

            setScreen(1);
            setIsAptCard(true);
          }
        }
      } else {
        const appointmentsdata = await api.get(
          `/v1/${practiseid}/appointments/${appointment?.patientid}/future`,
        );
        if (appointmentsdata.status == 200) {
          setIsFutureAppointment(true);
          console.log("appointment3 ", appointment);
          setSelectedAppointment({
            ...(appointmentsdata?.data?.[0] || {}),
            signintime: appointment?.signintime ?? null,
          });
          setScreen(1);
          setIsAptCard(true);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (fromPatientId) {
  //     fetchDashboardData(fromPatientId);

  //     // Remove `fromPatientId` from location.state after fetching
  //     navigate(location.pathname + location.search, {
  //       replace: true,
  //       state: { ...myData }
  //     });
  //   }
  // }, [fromPatientId, location.pathname, location.search, navigate]);
  const refereshpcard = async () => {
    try {
      setLoading(true);
      const requestPayload = {
        appointmentdate: currentDate,
        searchflag: selectedCard.patientid || null,
        dashfilter: tab, // Use tabFilter if provided, otherwise fall back to Redux tab
        filterarr: [],
        start: 0,
        limit: 0,
      };

      const response = await api.post(
        `/v1/${practiseid}/appointments/dashboard`,
        requestPayload,
      );
      if (response.status == 200) {
        const updatedPatient = response.data[0];

        setSelectedCard(updatedPatient);

        setFetchedData((prev) =>
          prev.map(
            (item) =>
              item.patientid === updatedPatient.patientid
                ? updatedPatient // replace
                : item, // keep old
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const updateeyeicon = async (order) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/orders/${order?.patientid}/update-hide-status`,
        {
          id: order.id,
          orderdate: dayjs(order.ts).format("YYYY-MM-DD"),
          is_hide: "Y",
        },
      );
      if (response.status === 200) {
        // 🧠 update only that order in fetchedData
        setFetchedData((prev) =>
          prev.map((patient) => {
            if (patient.patientid !== order.patientid) return patient;

            return {
              ...patient,
              orders: patient.orders.map((o) =>
                o.id === order.id
                  ? { ...o, is_hide: "Y" } // update locally
                  : o,
              ),
            };
          }),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUpdateFrontDesk = async ({ frontDesk, data }) => {
    try {
      setIsLoader(true);
      const response = await api.put(
        `/v1/${practiseid}/appointments/patient/${data.patientid}/front_desk`,
        {
          appointmentid: data.appointmentid,
          is_front_desk: frontDesk,
        },
      );
      if (response.status === 200) {
        setFetchedData((prevData) =>
          prevData.map((item) =>
            item.id === data?.id ? { ...item, is_front_desk: frontDesk } : item,
          ),
        );
      }
    } catch (error) {
      console.error("Error updating front desk:", error);
    } finally {
      setIsLoader(false);
    }
  };
  return (
    <div className="h-full">
      <SideNavLayout>
        <div className="sticky bg-[#FAFAF9] top-16 z-20">
          <NavigationMenu
            selectedFilterName={selectedFilterName}
            setSelectedFilterName={setSelectedFilterName}
            appliedFilter={appliedFilter}
            setAppliedFilter={setAppliedFilter}
            setFiltermodal={setFiltermodal}
            dob={dob}
            dbscount={dbscount}
            isCardView={isCardView}
            setIsCardView={setIsCardView}
            setStartDate={setStartDate}
            startdate={startdate}
            fetchDashboardData={fetchDashboardData}
            setDashboardfilter={setDashboardfilter}
            searchedUser={searchedUser}
            setSearchedUser={setSearchedUser}
            clearSearchUser={clearSearchUser}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        </div>
        {!fetchedData ||
        (fetchedData.length === 0 && !loading && isloaderactive.current) ? (
          <div className="w-full py-10 flex items-center justify-center font-normal text-xl text-[#000000]">
            No appointments found
          </div>
        ) : (
          <div
            className={`mt-6 ${
              !isCardView
                ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 items-start"
                : "flex flex-wrap gap-8 justify-center"
            }`}
          >
            {loading ? (
              <div className="flex justify-center items-center w-full mt-8">
                <CircularProgress />
              </div>
            ) : (
              fetchedData.map((x, index) =>
                !isCardView ? (
                  <CardView
                    key={index}
                    className="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4"
                    data={x}
                    dob={dob.current}
                    insertdata={insertdata}
                    setFetchedData={setFetchedData}
                    alldata={fetchedData}
                    modalopen={openModal}
                    setIsStatusNotesPopUp={setIsStatusNotesPopUp}
                    fetchpcarddata={fetchpcarddata}
                    refreshDashboard={refreshDashboard}
                    setToastSeverity={setToastSeverity}
                    setToastMessage={setToastMessage}
                    setOpenToast={setOpenToast}
                    markAsComplete={markAsComplete}
                    markAscancel={markAscancel}
                    handleconfirmScheduleClick={handleconfirmScheduleClick}
                    scheduleStates={scheduleStates}
                    paymentdetails={validpayments}
                    selectedOrder={selectedOrder}
                    setSelectedOrder={setSelectedOrder}
                    setSelectedCard={setSelectedCard}
                    searchTerm={searchTerm}
                    setChat={setChat}
                    fetchedData={fetchedData}
                    handleschedular={handleschedular}
                  />
                ) : (
                  <ExpandedView
                    key={index}
                    dob={dob.current}
                    paymentdetails={validpayments}
                    insertdata={insertdata}
                    setFetchedData={setFetchedData}
                    alldata={fetchedData}
                    setIsStatusNotesPopUp={setIsStatusNotesPopUp}
                    fetchpcarddata={fetchpcarddata}
                    fetchedData={fetchedData}
                    setToastSeverity={setToastSeverity}
                    setToastMessage={setToastMessage}
                    setOpenToast={setOpenToast}
                    markAsComplete={markAsComplete}
                    markAscancel={markAscancel}
                    handleconfirmScheduleClick={handleconfirmScheduleClick}
                    scheduleStates={scheduleStates}
                    selectedOrder={selectedOrder}
                    setSelectedOrder={setSelectedOrder}
                    searchTerm={searchTerm}
                    modalopen={openModal}
                    fetchUpdateFrontDesk={fetchUpdateFrontDesk}
                    updateeyeicon={updateeyeicon}
                    rpmvalues={rpmvalues}
                    data={x}
                    setChat={setChat}
                    refreshDashboard={refreshDashboard}
                    setSelectedCard={setSelectedCard}
                    handleschedular={handleschedular}
                    // fetchDashboardData={fetchDashboardData}
                  />
                ),
              )
            )}
          </div>
        )}

        <DashboardFilterModal
          fetchDashboardData={fetchDashboardData}
          isOpen={filtermodal}
          onClose={() => {
            setFiltermodal(false);
          }}
          selectedFilterName={selectedFilterName}
          setSelectedFilterName={setSelectedFilterName}
          appliedFilter={appliedFilter}
          setAppliedFilter={setAppliedFilter}
        />
        <ImagingModal
          dob={dob.current || data.dob}
          data={data.current}
          setImagingModal={setImagingModal}
          imagingmodal={imagingmodal}
        />
        {/* <PcardPopup setPcard={setIsPcard} data={selectedCard} isPcard={isPcard} /> */}
        {isPcard ? (
          <PcardPopupNew
            refereshpcard={refereshpcard}
            setPcard={setIsPcard}
            dob={dob.current || data.dob}
            data={selectedCard}
            isPcard={isPcard}
          />
        ) : (
          <></>
        )}
        {isModalOpen ? (
          <ModalOverlay
            setFetchedData={setFetchedData}
            fetchedData={fetchedData}
            isloaderactive={isloaderactive}
            dob={dob.current || data.dob}
            modaldata={selectedCard}
            searchdate={searchdate}
            isOpen={isModalOpen}
            fetchpcarddata={fetchpcarddata}
            onClose={closeModal}
          />
        ) : (
          <></>
        )}
        <StatusNotesPopUp
          isStatusNotesPopUp={isStatusNotesPopUp}
          setIsStatusNotesPopUp={setIsStatusNotesPopUp}
        />
        {dashboardfilter && (
          <Dashfilter
            setDashboardfilter={setDashboardfilter}
            dashboardfilter={dashboardfilter}
          />
        )}
        {/*        
        {appointmentModal==1?<CreateAppointment
            isfutureappointment={true} 
                  
       
           setScreen={setAppointmentModal} 
              flow={'db'} //db=>dashboard
            selectedAppointment={futureappoinments[0]} 
             appointmentCardopen={true} 
                />
                :<></>} */}
        <ModalSwitch
          isfutureappointment={isfutureappointment}
          setIsFutureAppointment={setIsFutureAppointment}
          setScreen={setScreen}
          screen={screen}
          selectedDate={currentDate}
          flow="db"
          fetchScheduleData={() => {}}
          appointmentCardopen={appointmentCardopen}
          setIsappointmentCardOpen={setIsappointmentCardOpen}
          isAptcard={isAptCard}
          setIsAptcard={setIsAptCard}
          // selectedAppointment={selectedAppointment}
          selectedAppointment={{
            ...selectedAppointment,
            signintime: selectedAppointment?.signintime ?? null,
          }}
        />
        {chat ? (
          <ChatWrapper
            setChat={setChat}
            patientdata={selectedCard}
            flow={"comment"}
          />
        ) : (
          <></>
        )}
        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
        <Backdrop open={isloader} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </SideNavLayout>
    </div>
  );
};

export default CareLanding;
